import type { OwaDate } from 'owa-datetime';
import type { DateRange } from './DateRange';
import { toDateRangeArray } from './DateRange';
import isDSTTransitionDate from './isDSTTransitionDate';

/**
 * Gets the DST transition date from the provided date range.
 *
 * @param dateRange The date range to check for DST transitions
 * @returns The date in the range that is a DST transition date, or undefined if none is found
 */
export default function getDSTTransitionDateInRange(dateRange: DateRange): OwaDate | undefined {
    const dates = toDateRangeArray(dateRange);

    return dates.find(isDSTTransitionDate);
}
